/**
 * v3/index.js
 * Autogenerated via generateMockRouteIndexes.js
 * DO NOT MODIFY THIS FILE DIRECTLY.
 */

import chats from './chats';
import clinician from './clinician';
import messages from './messages';

/** @type {import('../../mockRequestHandler').EndpointMockConfig} */
export default {
  ...chats,
  ...clinician,
  ...messages
};
